import { useMapCoreManager } from './contexts/MapCoreManager/Provider'
import Navbar from './components/Navbar'
import SimpleBaseLayerToogle from './components/SimpleBaseLayerToogle'
import StaticPointerInTheCenter from './components/StaticPointerInTheCenter'
import MarkingDataCard from './components/MarkingDataCard'
import EntitiesDrawer from './components/EntitiesDrawer'
import { Box } from '@chakra-ui/react'

export default function ImpactoMapComponent() {
  const { baseLayerSourceName, simpleBaseLayerToogleButton, selectionMode, markingDataCard, mapRef, navbar } =
    useMapCoreManager()

  return (
    <Box pos="relative" w="100%" h="100%">
      <Box w="100%" h="100%" ref={mapRef} />

      {navbar && <Navbar />}
      {markingDataCard && <MarkingDataCard />}
      {simpleBaseLayerToogleButton && <SimpleBaseLayerToogle defaultActiveBaseLayer={baseLayerSourceName} />}
      {selectionMode == 'STATIC_POINTER_IN_THE_CENTER' && <StaticPointerInTheCenter />}
      {selectionMode == 'STATIC_POINTER_IN_THE_CENTER' && (
        <>
          <Box position="absolute" top="50%" left="0" right="0" height="1px" bg="red" opacity={0.3} zIndex="9" />
          <Box position="absolute" left="50%" top="0" bottom="0" width="1px" bg="red" opacity={0.3} zIndex="9" />
        </>
      )}
      <EntitiesDrawer />
    </Box>
  )
}
